import React, { createContext, useContext, useState, useRef, useEffect, useCallback } from 'react';
import Hls from 'hls.js';

const AudioContext = createContext();

// Station data from the problem statement
const STATION_DATA = {
  station: {
    id: 1,
    name: "The NU Vibe",
    shortcode: "wnuv",
    description: "Nashville's #1 Internet Radio Station With The Hottest Blends",
    listen_url: "https://snapdismedia.stream:8000/radio.mp3",
    url: "https://snapdismedia.stream/public/wnuv_the_nu_vibe",
    public_player_url: "https://snapdismedia.stream/public/wnuv",
    is_public: true,
    mounts: [
      {
        id: 38,
        name: "/radio.mp3 (192kbps MP3)",
        url: "https://snapdismedia.stream:8000/radio.mp3",
        bitrate: 192,
        format: "mp3",
        listeners: { total: 2, unique: 2, current: 2 },
        path: "/radio.mp3",
        is_default: true
      }
    ],
    remotes: [
      {
        id: 8,
        name: "SkyView Radio",
        url: "https://snapdismedia.stream/listen/skyview_radio/radio.mp3",
        bitrate: 128,
        format: "mp3",
        listeners: { total: 0, unique: 0, current: 0 }
      },
      {
        id: 15,
        name: "The NU Vibe",
        url: "https://sapircast.caster.fm/5UJbM",
        bitrate: 96,
        format: "opus",
        listeners: { total: 0, unique: 0, current: 0 }
      }
    ],
    hls_enabled: true,
    hls_url: "https://snapdismedia.stream/hls/wnuv/live.m3u8"
  },
  listeners: { total: 2, unique: 2, current: 2 },
  live: {
    is_live: false,
    streamer_name: "",
    broadcast_start: null,
    art: null
  },
  now_playing: {
    sh_id: 1118997,
    played_at: 1772051166,
    duration: 286,
    playlist: "WEST COAST",
    streamer: "",
    is_request: false,
    song: {
      id: "d3c064d0cedfb4d7f0c22ece6b3cd5d6",
      art: "https://snapdismedia.stream/api/station/wnuv/art/8d28f2fa04ce0b52c83b1f76-1719599358.jpg",
      text: "Compton Most Wanted - Late Night Hype",
      artist: "Compton Most Wanted",
      title: "Late Night Hype",
      album: "IT'S A COMPTON THANG",
      genre: ""
    },
    elapsed: 223,
    remaining: 63
  },
  playing_next: {
    cued_at: 1772051160,
    played_at: 1772051456,
    duration: 240.5,
    playlist: "TOP 80'S",
    is_request: false,
    song: {
      id: "f047f77b1fd3c4214c3106e73396668d",
      art: "https://snapdismedia.stream/api/station/wnuv/art/ca138524c71b0ac040c1d697-1704291836.jpg",
      text: "Biz Markie - Just A Friend",
      artist: "Biz Markie",
      title: "Just A Friend",
      album: "The Biz Never Sleeps",
      genre: "Hip Hop; Rap"
    }
  },
  song_history: [
    {
      sh_id: 1118992,
      played_at: 1772050893,
      duration: 273,
      playlist: "Mixed Up Blends Vol1",
      song: {
        id: "272bc94b704c697485cd2f66e7a9ef5b",
        art: "https://snapdismedia.stream/api/station/wnuv/art/d220fca8e13cd71ebd444f40-1676495431.jpg",
        text: "Stetsasonic - On Fire",
        artist: "Stetsasonic",
        title: "On Fire",
        album: "Mixed Up Blends Vol#1",
        genre: "Mixtape"
      }
    },
    {
      sh_id: 1118989,
      played_at: 1772050641,
      duration: 251,
      playlist: "Top 25 part 1",
      song: {
        id: "d3698e71028deddb7509c0975cb159dc",
        art: "https://snapdismedia.stream/api/station/wnuv/art/bf6b6a89e00de0cb9a3a337a-1654516440.jpg",
        text: "Wu-Tang Clan - C.R.E.A.M.",
        artist: "Wu-Tang Clan",
        title: "C.R.E.A.M.",
        album: "Enter the Wu-Tang (36 Chambers)",
        genre: "Hip-Hop"
      }
    },
    {
      sh_id: 1118986,
      played_at: 1772050365,
      duration: 278,
      playlist: "TOP 80'S",
      song: {
        id: "d598e6a3f2c011a66a7d91ba11d50a72",
        art: "https://snapdismedia.stream/api/station/wnuv/art/94d4c2e448f3197ede35cc67-1704291855.jpg",
        text: "Run D.M.C. - It's Like That",
        artist: "Run D.M.C.",
        title: "It's Like That",
        album: "The First Album",
        genre: "Hip-Hop"
      }
    },
    {
      sh_id: 1118981,
      played_at: 1772050089,
      duration: 278,
      playlist: "TOP 80'S",
      song: {
        id: "9822dd03efdc1943feb0517c14c6fd0b",
        art: "https://snapdismedia.stream/api/station/wnuv/art/bb4bb36bc68abb3710d7684d-1704291791.jpg",
        text: "Public Enemy - Public Enemy No. 1",
        artist: "Public Enemy",
        title: "Public Enemy No. 1",
        album: "Yo! Bum Rush The Show",
        genre: "Rap"
      }
    },
    {
      sh_id: 1118976,
      played_at: 1772049813,
      duration: 276,
      playlist: "Nashville Hip-Hop",
      song: {
        id: "69eb7fd9c091774426d5cdec6a8e4681",
        art: "https://snapdismedia.stream/api/station/wnuv/art/803eb8db85de6364e8bddf7e",
        text: "Tk - Super Nigga(Remastered)",
        artist: "Tk",
        title: "Super Nigga(Remastered)",
        album: "",
        genre: ""
      }
    }
  ]
};

const API_URL = process.env.REACT_APP_BACKEND_URL 
  ? `${process.env.REACT_APP_BACKEND_URL}/api/station/nowplaying`
  : 'https://snapdismedia.stream/api/nowplaying/wnuv';

const STATION_CONFIG_URL = process.env.REACT_APP_BACKEND_URL 
  ? `${process.env.REACT_APP_BACKEND_URL}/api/station/config`
  : null;

// Default to the backend proxy to avoid CORS issues, fallback to direct if no backend
const DEFAULT_STATION_API = process.env.REACT_APP_BACKEND_URL 
  ? `${process.env.REACT_APP_BACKEND_URL}/api/station/nowplaying`
  : 'https://snapdismedia.stream/api/nowplaying/wnuv';

export function AudioProvider({ children }) {
  const audioRef = useRef(null);
  const hlsRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyzerRef = useRef(null);
  const gainNodeRef = useRef(null);
  const sourceNodeRef = useRef(null);
  const userTriedToPlayRef = useRef(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(0.8);
  const [isMuted, setIsMuted] = useState(false);
  const [currentStream, setCurrentStream] = useState(STATION_DATA.station.listen_url);
  const [streamType, setStreamType] = useState('mp3');
  const [stationData, setStationData] = useState(STATION_DATA);
  const [stationConfig, setStationConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [elapsed, setElapsed] = useState(STATION_DATA.now_playing.elapsed);
  // Use state for API URL to properly trigger re-renders and useEffect dependencies
  const [stationApiUrl, setStationApiUrl] = useState(DEFAULT_STATION_API);
  const [configLoaded, setConfigLoaded] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  // Fetch station config on mount
  useEffect(() => {
    const fetchConfig = async () => {
      if (!STATION_CONFIG_URL) {
        // No config URL, use default API and mark as loaded
        setConfigLoaded(true);
        return;
      }
      try {
        const response = await fetch(STATION_CONFIG_URL);
        if (response.ok) {
          const config = await response.json();
          setStationConfig(config);
          // Update the API URL state if provided, otherwise keep default
          if (config.station_api_url && config.station_api_url.trim()) {
            setStationApiUrl(config.station_api_url);
          } else {
            // Ensure we use the default API URL
            setStationApiUrl(DEFAULT_STATION_API);
          }
          // Update station data with config values
          setStationData(prev => ({
            ...prev,
            station: {
              ...prev.station,
              name: config.station_name || prev.station.name,
              description: config.station_description || prev.station.description,
              listen_url: config.stream_url || prev.station.listen_url,
              hls_url: config.hls_url || prev.station.hls_url
            }
          }));
          // Set the initial stream URL from config
          if (config.stream_url) {
            setCurrentStream(config.stream_url);
          }
        }
      } catch (err) {
        console.log('Failed to fetch station config');
      } finally {
        // Mark config as loaded regardless of success/failure
        setConfigLoaded(true);
      }
    };
    fetchConfig();
  }, []);

  // Setup Web Audio API for real frequency visualization
  const setupAudioAnalyzer = useCallback(() => {
    if (!audioRef.current || sourceNodeRef.current) return;
    
    try {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!audioContextRef.current) {
        audioContextRef.current = new AudioContextClass();
      }
      
      const ctx = audioContextRef.current;
      
      // Resume if suspended
      if (ctx.state === 'suspended') {
        ctx.resume();
      }
      
      // Create nodes
      analyzerRef.current = ctx.createAnalyser();
      analyzerRef.current.fftSize = 128;
      analyzerRef.current.smoothingTimeConstant = 0.8;
      
      gainNodeRef.current = ctx.createGain();
      gainNodeRef.current.gain.value = volume;
      
      // Connect: source -> analyzer -> gain -> destination
      sourceNodeRef.current = ctx.createMediaElementSource(audioRef.current);
      sourceNodeRef.current.connect(analyzerRef.current);
      analyzerRef.current.connect(gainNodeRef.current);
      gainNodeRef.current.connect(ctx.destination);
      
      console.log('Audio analyzer connected');
    } catch (err) {
      console.log('Could not setup analyzer:', err.message);
    }
  }, [volume]);

  // Get frequency data for visualizer
  const getFrequencyData = useCallback(() => {
    if (!analyzerRef.current) return null;
    const dataArray = new Uint8Array(analyzerRef.current.frequencyBinCount);
    analyzerRef.current.getByteFrequencyData(dataArray);
    return dataArray;
  }, []);

  // Fetch live station data - now depends on stationApiUrl state
  const fetchStationData = useCallback(async (isManualRefresh = false) => {
    if (isManualRefresh) {
      setIsRefreshing(true);
    }
    try {
      console.log('Fetching station data from:', stationApiUrl);
      const response = await fetch(stationApiUrl);
      if (response.ok) {
        const data = await response.json();
        setStationData(prev => ({
          ...prev,
          ...data,
          song_history: data.song_history || prev.song_history
        }));
        setElapsed(data.now_playing?.elapsed || 0);
      } else {
        console.log('Station API response not ok:', response.status);
      }
    } catch (err) {
      console.log('Station fetch error:', err.message);
    } finally {
      if (isManualRefresh) {
        setIsRefreshing(false);
      }
    }
  }, [stationApiUrl]);

  // Poll for updates every 10 seconds - ONLY after config is loaded
  useEffect(() => {
    if (!configLoaded) {
      console.log('Waiting for config to load before starting poll...');
      return;
    }
    
    console.log('Config loaded, starting poll with URL:', stationApiUrl);
    // Fetch immediately once config is ready
    fetchStationData();
    
    // Then set up polling
    const interval = setInterval(fetchStationData, 10000);
    return () => clearInterval(interval);
  }, [configLoaded, stationApiUrl, fetchStationData]);

  // Update elapsed time
  useEffect(() => {
    let interval;
    if (isPlaying && stationData.now_playing?.duration) {
      interval = setInterval(() => {
        setElapsed(prev => {
          if (prev >= stationData.now_playing.duration) {
            fetchStationData();
            return 0;
          }
          return prev + 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isPlaying, stationData.now_playing?.duration, fetchStationData]);

  // Initialize audio element
  useEffect(() => {
    const audio = new Audio();
    audio.crossOrigin = 'anonymous';
    audio.preload = 'none';
    audio.volume = volume;
    audioRef.current = audio;

    const handlePlaying = () => {
      setIsPlaying(true);
      setIsLoading(false);
      setError(null);
    };
    const handlePause = () => setIsPlaying(false);
    const handleError = (e) => {
      console.error('Audio element error:', e);
      if (userTriedToPlayRef.current) {
        setError('Stream error. Try another quality.');
      }
      setIsLoading(false);
    };
    const handleWaiting = () => setIsLoading(true);
    const handleCanPlay = () => {
      setIsLoading(false);
      setError(null);
    };
    const handleLoadedData = () => {
      setIsLoading(false);
    };

    audio.addEventListener('playing', handlePlaying);
    audio.addEventListener('pause', handlePause);
    audio.addEventListener('error', handleError);
    audio.addEventListener('waiting', handleWaiting);
    audio.addEventListener('canplay', handleCanPlay);
    audio.addEventListener('loadeddata', handleLoadedData);

    return () => {
      audio.removeEventListener('playing', handlePlaying);
      audio.removeEventListener('pause', handlePause);
      audio.removeEventListener('error', handleError);
      audio.removeEventListener('waiting', handleWaiting);
      audio.removeEventListener('canplay', handleCanPlay);
      audio.removeEventListener('loadeddata', handleLoadedData);
      audio.pause();
      audio.src = '';
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }
    };
  }, []);

  // Handle stream changes
  const loadStream = useCallback((url, type = 'mp3') => {
    const audio = audioRef.current;
    
    // Cleanup previous HLS instance
    if (hlsRef.current) {
      hlsRef.current.destroy();
      hlsRef.current = null;
    }

    setCurrentStream(url);
    setStreamType(type);
    setError(null);

    if (type === 'hls' && Hls.isSupported()) {
      setIsLoading(true);
      const hls = new Hls({
        enableWorker: true,
        lowLatencyMode: true
      });
      hls.loadSource(url);
      hls.attachMedia(audio);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        setIsLoading(false);
      });
      hls.on(Hls.Events.ERROR, (event, data) => {
        if (data.fatal) {
          setError('HLS stream error. Try MP3 quality.');
          setIsLoading(false);
        }
      });
      hlsRef.current = hls;
    } else if (type === 'hls' && audio.canPlayType('application/vnd.apple.mpegurl')) {
      // Native HLS support (Safari)
      audio.src = url;
    } else {
      // For MP3 streams, just set the source
      audio.src = url;
    }
  }, []);

  const play = useCallback(() => {
    const audio = audioRef.current;
    if (!audio) return;
    
    setError(null);
    userTriedToPlayRef.current = true;
    setIsLoading(true);
    
    // Set source if not already set
    if (!audio.src || audio.src === '' || audio.src === window.location.href) {
      audio.src = currentStream;
      audio.load();
    }
    
    // Play with promise handling
    const playPromise = audio.play();
    
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          setIsLoading(false);
          setIsPlaying(true);
          // Setup analyzer after successful play
          setupAudioAnalyzer();
        })
        .catch(err => {
          console.error('Play error:', err);
          // Try reloading and playing again
          audio.load();
          audio.play().catch(e => {
            setError('Failed to play. Click again or try another stream.');
            setIsLoading(false);
          });
        });
    }
  }, [currentStream, setupAudioAnalyzer]);

  const pause = useCallback(() => {
    audioRef.current?.pause();
  }, []);

  const togglePlay = useCallback(() => {
    if (isPlaying) {
      pause();
    } else {
      play();
    }
  }, [isPlaying, play, pause]);

  const changeVolume = useCallback((newVolume) => {
    const vol = Math.max(0, Math.min(1, newVolume));
    setVolume(vol);
    
    // Use gain node if Web Audio is connected
    if (gainNodeRef.current) {
      gainNodeRef.current.gain.value = vol;
    } else if (audioRef.current) {
      // Fallback to audio element volume
      audioRef.current.volume = vol;
    }
  }, []);

  const toggleMute = useCallback(() => {
    const newMuted = !isMuted;
    
    if (gainNodeRef.current) {
      gainNodeRef.current.gain.value = newMuted ? 0 : volume;
    } else if (audioRef.current) {
      audioRef.current.muted = newMuted;
    }
    setIsMuted(newMuted);
  }, [isMuted, volume]);

  // Refresh stream - reload to get back to "live"
  const refreshStream = useCallback(() => {
    const audio = audioRef.current;
    if (!audio) return;
    
    const wasPlaying = isPlaying;
    
    // Stop current playback
    audio.pause();
    
    // Clear the source and reload to get fresh stream
    audio.src = '';
    audio.load();
    
    // Set new source with cache-busting
    const streamUrl = currentStream.includes('?') 
      ? `${currentStream}&_t=${Date.now()}` 
      : `${currentStream}?_t=${Date.now()}`;
    audio.src = streamUrl;
    audio.load();
    
    // Resume playing if it was playing before
    if (wasPlaying) {
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise.catch(err => {
          console.error('Refresh play error:', err);
        });
      }
    }
    
    // Also fetch latest station data
    fetchStationData(true);
  }, [isPlaying, currentStream, fetchStationData]);

  const switchStream = useCallback((mount) => {
    const wasPlaying = isPlaying;
    const audio = audioRef.current;
    
    if (audio) {
      audio.pause();
      audio.src = '';
    }
    
    loadStream(mount.url, mount.format === 'hls' ? 'hls' : 'mp3');
    
    if (wasPlaying) {
      setTimeout(() => {
        audio.play().catch(err => {
          console.error('Switch stream play error:', err);
          setError('Failed to switch stream.');
        });
      }, 200);
    }
  }, [isPlaying, loadStream]);

  const switchToHLS = useCallback(() => {
    const wasPlaying = isPlaying;
    const audio = audioRef.current;
    
    if (audio) {
      audio.pause();
      audio.src = '';
    }
    
    loadStream(STATION_DATA.station.hls_url, 'hls');
    
    if (wasPlaying) {
      setTimeout(() => {
        audio.play().catch(err => {
          console.error('Switch to HLS error:', err);
          setError('Failed to switch to HLS.');
        });
      }, 200);
    }
  }, [isPlaying, loadStream]);

  return (
    <AudioContext.Provider value={{
      isPlaying,
      volume,
      isMuted,
      currentStream,
      streamType,
      stationData,
      isLoading,
      error,
      elapsed,
      audioRef,
      getFrequencyData,
      play,
      pause,
      togglePlay,
      changeVolume,
      toggleMute,
      switchStream,
      switchToHLS,
      loadStream,
      fetchStationData,
      refreshStream,
      stationConfig,
      isRefreshing
    }}>
      {children}
    </AudioContext.Provider>
  );
}

export const useAudio = () => {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error('useAudio must be used within an AudioProvider');
  }
  return context;
};
